<template>
  <div :class="['app-menu', { 'is-toggled': isToggled }]">
    <div class="topbar subtopbar container-fluid pl-0 pr-0" data-navbarbg="skin5">
      <nav class="navbar top-navbar navbar-dark">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              class="nav-link sidebartoggler waves-effect waves-light"
              href="javascript:void(0)"
              data-sidebartype="mini-sidebar"
              @click="sideBarToggler()" >
              <div
                :class="['burger-icon', { 'is-toggled': isToggled }]">
                <div class="bar1"></div>
                <div class="bar2"></div>
                <div class="bar3"></div>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <h3 class="text-white mb-0 page-title" ref="pageTitle" id="pageTitle">
              <template
                v-if="$breadcrumbs && $breadcrumbs.length > 0 && $breadcrumbs[0].meta.title"
              >{{ $lang.messages[$breadcrumbs[0].meta.title] }}</template>
            </h3>
          </li>
        </ul>
        <div class="page-breadcrumb d-none d-lg-block">
          <div class="row">
            <div class="col-12 d-flex no-block align-items-center">
              <div class="ml-auto text-right">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb" v-if="$breadcrumbs && $breadcrumbs.length > 0">
                    <template v-for="(obj) in $breadcrumbs[0].meta.breadcrumb">
                      <li :class="{'breadcrumb-item': true, 'active':true }" :key="obj.path">
                        <a :href="obj.link" v-if="obj.link">{{ $lang.messages[obj.name] }}</a>
                        <template v-else>{{ $lang.messages[obj.name] }}</template>
                      </li>
                    </template>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <div class="sidebar-wrapper">
      <aside class="sidebar left-sidebar" data-sidebarbg="skin5">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar">
          <!-- Sidebar navigation-->
          <nav class="sidebar-nav">
            <ul id="sidebarnav">
              <li class="sidebar-item px-3 d-flex menu-user-type align-items-center py-3">
                <img
                  :src="image ? image: '/images/icon_profile.svg'"
                  width="30"
                  height="30"
                  class="sidebar-menu-icon rounded-circle header-uer-pic mr-2"
                />
                <p class="sidebar-link waves-effect waves-dark mb-0 user-type">
                  <span class="hide-menu mb-0">{{ access_right.name }}</span>
                  <br />
                  <span class="hide-menu text-secondary font-16 op-5">{{ user.name || user.email || client.business_name }}</span>
                </p>
              </li>
              <li class="sidebar-item drop-down-menu" v-if="access_right.menu_reports">
                <a
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="#ddm-1"
                  aria-expanded="false"
                  data-toggle="collapse"
                >
                  <img
                    src="/images/icon_reports_active.svg"
                    width="20"
                    height="27"
                    class="mr-3 sidebar-meni-icon"
                  />
                  <span class="hide-menu">{{$lang.messages.reports}}</span>
                </a>
                <ul id="ddm-1" aria-expanded="false" class="collapse first-level sidebar-sub-nav">
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/sales-summary' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.sales_summary}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/sales_item' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.sales_by_item}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/sales_category' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.sales_by_category}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/sales_employee' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.sales_by_employee}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/sales_payment' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.sales_by_payment_type}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/sales_receipts' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.receipts}}</span>
                    </router-link>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="access_right.menu_app && client.is_menu_app && client.menu_app">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/rating' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.rating_review}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/sales_discounts' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.discounts}}</span>
                    </router-link>
                  </li>
                  <!-- <li class="sidebar-item">
                    <a href="/sales_taxes" class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.taxes}}</span>
                    </a>
                  </li> -->
                  <li class="sidebar-item" v-if="client.shifts">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/sales_shifts' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.shifts}}</span>
                    </router-link>
                  </li>
                </ul>
              </li>

              <li class="sidebar-item drop-down-menu" v-if="access_right.menu_items || access_right.create_items">
                <a
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="#ddm-2"
                  aria-expanded="false"
                  data-toggle="collapse"
                >
                  <img
                    src="/images/icon_items.svg"
                    width="25"
                    height="30"
                    class="mr-3 sidebar-meni-icon"
                  />
                  <span class="hide-menu">{{$lang.messages.items}}</span>
                </a>
                <ul id="ddm-2" aria-expanded="false" class="collapse first-level sidebar-sub-nav">
                  <router-link v-if="access_right.menu_items || access_right.create_items"
                    to="/items"
                    @click.native="setsidebartype">
                    <li class="sidebar-item">
                      <a class="sidebar-link">
                        <span class="hide-menu">{{$lang.messages.item_list}}</span>
                      </a>
                    </li>
                  </router-link>
                  <router-link v-if="access_right.menu_items || access_right.create_items"
                    to="/category"
                    @click.native="setsidebartype">
                    <li class="sidebar-item">
                      <a class="sidebar-link">
                        <span class="hide-menu">{{$lang.messages.categories}}</span>
                      </a>
                    </li>
                  </router-link>
                  <router-link v-if="access_right.menu_items"
                    to="/discount"
                    @click.native="setsidebartype">
                    <li class="sidebar-item">
                      <a class="sidebar-link">
                        <span class="hide-menu">{{$lang.messages.discounts}}</span>
                      </a>
                    </li>
                  </router-link>
                  <router-link v-if="access_right.menu_items"
                    to="/deleted-items"
                    @click.native="setsidebartype">
                    <li class="sidebar-item">
                      <a class="sidebar-link">
                        <span class="hide-menu">{{$lang.messages.recently_deleted_items}}</span>
                      </a>
                    </li>
                  </router-link>
                </ul>
              </li>

              <li class="sidebar-item drop-down-menu" v-if="access_right.menu_items">
                <a
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="#ddm-3"
                  aria-expanded="false"
                  data-toggle="collapse"
                >
                  <img
                    src="/images/icon_inventory_management.svg"
                    width="25"
                    height="30"
                    class="mr-3 sidebar-meni-icon"
                  />
                  <span class="hide-menu">{{$lang.messages.inventory_management}}</span>
                </a>
                <ul id="ddm-3" aria-expanded="false" class="collapse first-level sidebar-sub-nav">
                  <router-link
                    to="/purchase-order"
                    @click.native="setsidebartype">
                    <li class="sidebar-item">
                      <a class="sidebar-link">
                        <span class="hide-menu">{{$lang.messages.purchase_orders}}</span>
                      </a>
                    </li>
                  </router-link>
                  <!-- <li class="sidebar-item">
                    <a href="purchase-order" class="sidebar-link">
                      <span class="hide-menu">Advanced inventory</span>
                    </a>
                  </li>-->
                  <li class="sidebar-item" v-if="access_right.manage_transfer_order">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/transfer-orders' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.transfer_orders}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/stock-adjustment' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.stock_adjustments}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/inventory-count' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.inventory_counts}}</span>
                    </router-link>
                  </li>
                  <!-- <li class="sidebar-item">
                    <a href="/production" class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.productions}}</span>
                    </a>
                  </li> -->

                  <router-link
                    to="/supplier-list"
                    @click.native="setsidebartype">
                    <li class="sidebar-item">
                      <a class="sidebar-link">
                        <span class="hide-menu">{{$lang.messages.suppliers}}</span>
                      </a>
                    </li>
                  </router-link>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/inventory-history' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.inventory_history}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/inventory-valuation' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.inventory_valuation}}</span>
                    </router-link>
                  </li>
                </ul>
              </li>

              <li class="sidebar-item drop-down-menu" v-if="access_right.menu_employees">
                <a
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="#ddm-4"
                  aria-expanded="false"
                  data-toggle="collapse"
                >
                  <img
                    src="/images/icon_employees.svg"
                    width="25"
                    height="30"
                    class="mr-3 sidebar-meni-icon"
                  />
                  <span class="hide-menu">{{$lang.messages.employees}}</span>
                </a>

                <ul id="ddm-4" aria-expanded="false" class="collapse first-level sidebar-sub-nav">
                  <router-link
                    to="/employees"
                    @click.native="setsidebartype">
                    <li class="sidebar-item">
                      <a class="sidebar-link">
                        <span class="hide-menu">{{$lang.messages.employee_list}}</span>
                      </a>
                    </li>
                  </router-link>
                  <router-link v-if="access_right.manage_access_right"
                    to="/access-rights"
                    @click.native="setsidebartype">
                    <li class="sidebar-item">
                      <a class="sidebar-link">
                        <span class="hide-menu">{{$lang.messages.access_rights}}</span>
                      </a>
                    </li>
                  </router-link>
                  <li class="sidebar-item" v-if="client.time_clock">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/time-card' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.timecards}}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-item" v-if="client.time_clock">
                    <router-link
                      @click.native="setsidebartype"
                      :to="{ path: '/total-hours-worked' }"
                      class="sidebar-link">
                      <span class="hide-menu">{{$lang.messages.total_hours_worked}}</span>
                    </router-link>
                  </li>
                </ul>
              </li>

              <router-link
                to="/customers"
                @click.native="setsidebartype">
                <li class="sidebar-item" v-if="access_right.menu_customers">
                  <a class="sidebar-link waves-effect waves-dark sidebar-link" aria-expanded="false">
                    <img
                      src="/images/icon_customers.svg"
                      width="25"
                      height="30"
                      class="mr-3 sidebar-meni-icon"
                    />
                    <span class="hide-menu">{{$lang.messages.customers}}</span>
                  </a>
                </li>
              </router-link>

              <router-link
                to="/audit-log"
                @click.native="setsidebartype">
                <li class="sidebar-item">
                  <a class="sidebar-link waves-effect waves-dark sidebar-link" aria-expanded="false">
                    <img
                      src="/images/audit-log.svg"
                      width="25"
                      height="30"
                      class="mr-3 sidebar-meni-icon"
                    />
                    <span class="hide-menu">{{$lang.messages.audit_log}}</span>
                  </a>
                </li>
              </router-link>

              <router-link
                to="/business-resource"
                @click.native="setsidebartype">
                <li class="sidebar-item">
                  <a class="sidebar-link waves-effect waves-dark sidebar-link" aria-expanded="false">
                    <img
                      src="/images/business-resource.svg?t=1"
                      width="25"
                      height="30"
                      class="mr-3 sidebar-meni-icon"
                    />
                    <span class="hide-menu">{{$lang.messages.business_resources}}</span>
                  </a>
                </li>
              </router-link>

              <router-link
                to="/review"
                v-if="false"
                @click.native="setsidebartype">
                <li
                  class="sidebar-item"
                  v-if="access_right.menu_app && client.is_menu_app && client.menu_app"
                >
                  <a class="sidebar-link waves-effect waves-dark sidebar-link" aria-expanded="false">
                    <img
                      src="/images/review.svg"
                      width="25"
                      height="30"
                      class="mr-3 sidebar-meni-icon"
                    />
                    <span class="hide-menu">{{$lang.messages.review}}</span>
                  </a>
                </li>
              </router-link>

              <router-link
                to="/settings"
                @click.native="setsidebartype">
                <li class="sidebar-item">
                  <a class="sidebar-link waves-effect waves-dark sidebar-link" aria-expanded="false">
                    <img
                      src="/images/icon_settings.svg"
                      width="25"
                      height="30"
                      class="mr-3 sidebar-meni-icon"
                    />
                    <span class="hide-menu">{{$lang.messages.settings}}</span>
                  </a>
                </li>
              </router-link>

              <router-link
                to="/help"
                @click.native="setsidebartype">
                <li class="sidebar-item">
                  <a class="sidebar-link waves-effect waves-dark sidebar-link" aria-expanded="false">
                    <span class="mr-3 sidebar-meni-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512">
                      <path xmlns="http://www.w3.org/2000/svg" d="M512 346.5c0-74.628906-50.285156-139.832031-121.195312-159.480469C386.347656 83.140625 300.457031 0 195.5 0 87.699219 0 0 87.699219 0 195.5c0 35.132812 9.351562 69.339844 27.109375 99.371094L.71875 390.277344l95.410156-26.386719c27.605469 16.324219 58.746094 25.519531 90.886719 26.90625C206.660156 461.710938 271.867188 512 346.5 512c29.789062 0 58.757812-7.933594 84.210938-23.007812l80.566406 22.285156-22.285156-80.566406C504.066406 405.257812 512 376.289062 512 346.5zm-411.136719-15.046875l-57.117187 15.800781 15.800781-57.117187-3.601563-5.632813C38.972656 257.949219 30 227.171875 30 195.5 30 104.242188 104.242188 30 195.5 30S361 104.242188 361 195.5 286.757812 361 195.5 361c-31.671875 0-62.445312-8.972656-89.003906-25.945312zm367.390625 136.800781l-42.382812-11.726562-5.660156 3.683594C398.269531 474.464844 372.777344 482 346.5 482c-58.65625 0-110.199219-37.925781-128.460938-92.308594 89.820313-10.355468 161.296876-81.832031 171.65625-171.65625C444.074219 236.300781 482 287.84375 482 346.5c0 26.277344-7.535156 51.769531-21.789062 73.710938l-3.683594 5.660156zm0 0" fill="currentColor" data-original="#000000"/>
                      <path xmlns="http://www.w3.org/2000/svg" d="M180.5 271h30v30h-30zm0 0M225.5 150c0 8.519531-3.46875 16.382812-9.765625 22.144531l-35.234375 32.25V241h30v-23.394531l25.488281-23.328125C248.386719 182.929688 255.5 166.792969 255.5 150c0-33.085938-26.914062-60-60-60s-60 26.914062-60 60h30c0-16.542969 13.457031-30 30-30s30 13.457031 30 30zm0 0" fill="currentColor" data-original="#000000"/>
                    </svg>
                    </span>
                    <span class="hide-menu">{{ $lang.messages.help }}</span>
                  </a>
                </li>
              </router-link>
            </ul>
          </nav>
          <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
      </aside>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus"

export default {
  name: "Menu",
  data() {
    return {
      image: "",
      client: {
        shifts: false,
        time_clock: false,
        open_tickets: false,
        kitchen_printers: false,
        customer_display: false,
        dining_options: false,
        user_define_tickets: false,
        low_stock: false,
        negative_stock_alerts: false,
        menu_app: false,
        is_menu_app: false
      },
      loggedInUserEmail: "",
      access_right: {
        name: "",
        pos: false,
        back_office: false,
        menu_app: false,
        apply_discount_restricted: false,
        view_all_receiptis: false,
        manage_open_tickets: false,
        saved_open_tickets: false,
        shift_report: false,
        change_tax: false,
        purchase_returns: false,
        open_cash_drawer: false,
        edit_items: false,
        change_setting: false,
        access_livechat: false,
        menu_reports: false,
        menu_employees: false,
        menu_customers: false,
        edit_profile: false,
        menu_items: false,
        create_items: false,
        manage_billing: false,
        set_payment_type: false,
        set_taxes: false,
        manage_pos: false,
        kitchen_printer: false,
        dining_option: false,
        support: false
      },
      isToggled: false,
      user: {}
    }
  },

  methods: {
    getMe() {
      this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          if (res.days) {
            localStorage.setItem("days", res.days)
          }
          this.image = res.user.image
          this.access_right = res.access_right
          this.user = res.user
          localStorage.setItem(
            "accessright",
            JSON.stringify(res.access_right)
          )
        })
    },

    getGeneralSetting() {
      this.$api
        .getAPI({
          _action: "/backoffice-setting/general"
        })
        .then(res => {
          this.client = res
          localStorage.setItem("dining_options", this.client.dining_options)
          localStorage.setItem("customer_sharing", this.client.customer_sharing)
          localStorage.setItem("is_enable_b2b", this.client.is_enable_b2b)
        })
    },

    sideBarToggler() {
      this.isToggled = !this.isToggled
      $("#main-wrapper").toggleClass("mini-sidebar")
      if ($("#main-wrapper").hasClass("mini-sidebar")) {
        $(".sidebartoggler").prop("checked", !0)
        $("#main-wrapper").attr("data-sidebartype", "mini-sidebar")
      } else {
        $(".sidebartoggler").prop("checked", !1)
        $("#main-wrapper").attr("data-sidebartype", "full")
      }
    },

    setsidebartype() {
      var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width
      if (width < 1170) {
        $("#main-wrapper").attr("data-sidebartype", "mini-sidebar")
        $("#main-wrapper").addClass("mini-sidebar")
      } else {
        $("#main-wrapper").attr("data-sidebartype", "full")
        $("#main-wrapper").removeClass("mini-sidebar")
      }
    }
  },
  mounted() {
    this.getMe()
    this.getGeneralSetting()
    this.loggedInUserEmail = localStorage.getItem("loggedInUserEmail")
    EventBus.$on("DATA_PUBLISHED", () => {
      this.getGeneralSetting()
      this.getMe()
    })
    this.setsidebartype()
  },

  watch: {
    "$route": function() {
      this.isToggled = false
    }
  }
}
</script>
